<template>
  <div class="places-map">
    <google-map
      @ready="googleMapReady"
      @geometry-clicked="pointClicked"
      @marker-created="createPoint"
      ref="googleMap"
    ></google-map>
  </div>
</template>

<script>
import GoogleMap from '@/components/Maps/Google'

export default {
  name: 'places-map',
  props: {
    places: {
      type: Array,
      default: function () {
        return []
      }
    },
    drawingPlace: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mapIsReady: false
    }
  },
  computed: {
    points: function () {
      return this.places.map(place => {
        return {
          position: {
            lat: place.geometry.coordinates[1],
            lng: place.geometry.coordinates[0]
          },
          id: place._id
        }
      })
    }
  },
  watch: {
    points: function (points) {
      this.updateMapPlaces()
    },
    drawingPlace: function () {
      this.updateMapDrawingState()
    }
  },
  components: {
    'google-map': GoogleMap
  },
  methods: {
    googleMapReady: function () {
      this.mapIsReady = true
      this.updateMapPlaces()
      this.updateMapDrawingState()
    },
    updateMapPlaces: function () {
      if (!this.mapIsReady) return false
      this.$refs.googleMap.removeMarkers()
      for (const point of this.points) {
        this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createMarker({
          markerOptions: point
        }))
      }
    },
    updateMapDrawingState: function () {
      if (!this.mapIsReady || !this.drawingPlace) return false
      this.$refs.googleMap.drawMarker()
    },
    createPoint: function (position) {
      const point = {
        type: 'Point',
        coordinates: [
          position.lng(),
          position.lat()
        ]
      }
      this.$emit('point-created', point)
    },
    pointClicked: function ({ type, id }) {
      if (type !== 'Marker') return false
      this.$emit('point-clicked', id)
    }
  }
}
</script>

<style scoped>
.google-map {
  height: 100%;
  margin: 0;
  padding: 0;
}
.google-map-action {
  position: fixed;
  right: 53px;
  bottom: 23px;
  padding-top: 15px;
  margin-bottom: 0;
  z-index: 998;
}
</style>



// WEBPACK FOOTER //
// src/components/Maps/Places.vue